<script lang="ts">
  export let selectedValue = 0;
  export let chooseQty: (value: number) => void = () => {};
  // Function to set the selected value
  function selectQuantity(value: string | number) {
    selectedValue = +value;
    chooseQty(+selectedValue);
  }
  const values = [
    ["Any", 0],
    ["1", 1],
    ["2", 2],
    ["3", 3],
    ["4", 4],
    ["5+", 5],
  ];
</script>

<section class="qty">
  <h3 class="pf-400">Quantity</h3>
  <div>
    {#each values as [label, value]}
      <span
        class="pf-400 {selectedValue === value ? 'active' : ''}"
        on:click={() => selectQuantity(value)}
        on:keyup={() => selectQuantity(value)}
        role="button"
        tabindex="0"
      >
        {label}
      </span>
    {/each}
  </div>
</section>

<style lang="scss">
  .qty {
    display: grid;
    align-items: center;
    grid-template-columns: auto 1fr;
    gap: 0.3em;
    margin: 0;
    h3,
    span {
      font-size: 1em;
      margin: 0;
    }
    div {
      display: grid;
      align-content: center;
      gap: 0.3em;
      grid-template-columns: repeat(6, 1fr);
    }
    span {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0.3em 1em;
      border-radius: 40px;
      border: 1px solid #d8d8d8;
      background: #fff;
      line-height: 17px;
    }
    span:hover {
      background: #e7e9ff;
      transition: background-color 0.2s ease-in-out;
    }
    .active {
      background: #e7e9ff;
      border: 2px solid #747bdd;
    }
  }
</style>
